import React from "react";
import assetPath from "~/utils/assetPath";
import LayoutComponent from "~/components/LayoutComponent";
import Collections from "./Collections";

function action(context, params) {
  return {
    chunks: ["collections"],
    title: "Jigsaw Puzzles - Play Online for Free [130.000+ Puzzles]",
    description:
      "130.000+ free jigsaw puzzles. No registration or download required. Choose between 10 and 640 puzzle pieces. Have fun!",
    image: assetPath("frontpage_desktop", "jpg"),
    pathname: "/",
    component: (
      <LayoutComponent>
        <Choose>
          <When condition={context.path.includes("topics") && !!context.params.id}>
            <Collections type="topics" id={context.params.id} />
          </When>
          <When condition={context.path.includes("topics")}>
            <Collections type="topics" />
          </When>
          <Otherwise>
            <Collections />
          </Otherwise>
        </Choose>
      </LayoutComponent>
    )
  };
}

export default action;



// WEBPACK FOOTER //
// ./src/routes/collections/index.js